import { ENV } from '@configs/env';

export const useDocTitle = ({ location, projectName }) => {
    const organization = ENV.APP_NAME;
    const pathname = location.pathname;

    const segments = pathname.split('/').filter(Boolean);
    const lastSegment = segments[segments.length - 1];
    const secondLastSegment = segments[segments.length - 2];

    const formatSegment = (segment) =>
        segment
            ? segment
                  .split('-')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')
            : '';

    let title = organization;
    if (pathname !== '/') {
        title = lastSegment ? `${formatSegment(lastSegment)} | ${organization}` : organization;
        if (secondLastSegment && lastSegment?.match(/\d+$/)) {
            title = `${formatSegment(secondLastSegment)} (${formatSegment(lastSegment)}) | ${organization}`;
        }

        const isProjectDetailsRoute = /^\/(?:tenant\/)?projects\/[^/]+$/.test(pathname);
        const isChatRoute = /\/chat\//.test(pathname);

        if (isChatRoute) {
            const display = projectName && projectName !== 'Chat' ? ` | ${projectName}` : '';
            document.title = `Chat${display}`;
            return;
        } else if (isProjectDetailsRoute && projectName) {
            title = `${projectName} | ${organization}`;
        }
    }

    return document.title !== title && (document.title = title);
};
